import BaseServiceHttp from '../baseService'
class SugestoesObras extends BaseServiceHttp {
  constructor(id) {
    const resource = 'sugestoes-obras'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new SugestoesObras(id)
